import { gql } from '@apollo/client';

const query = gql`
  query GetEnquiries($userId: String, $after: String, $first: Int) {
    enquiries(userId: $userId, after: $after, first: $first) {
      edges {
        node {
          id
          message
          createdAt
          enquiryAssets(first: 3) {
            edges {
              node {
                id
                url
              }
            }
          }
          enquiryResponse {
            id
            message
          }
          profile {
            id
            displayName
            logo
            vanityUrlPath
            suburb
            stateCode
            status
            package {
              id
              name
              sort
            }
            contacts {
              type
              value
            }
          }
          category {
            name
            id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

module.exports = query;
